
{
  "familyId": "MET-OPP-DRIEHOEK",
  "questions": [
    {
      "id": "MET-OPP-DRIEHOEK-001",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "multiple_choice",
      "question": "Een architect tekent een driehoekig raam met een basis van 10 cm en een hoogte van 6 cm. Wat is de oppervlakte?",
      "context": null,
      "options": ["30 cm²", "60 cm²", "16 cm²", "36 cm²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 10,
            "height": 6,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte driehoek",
            "content": "Oppervlakte driehoek = (basis × hoogte) ÷ 2. Een driehoek is de helft van een rechthoek! Dus: (10 × 6) ÷ 2 = 30 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_base_height",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "De formule voor de oppervlakte van een driehoek is: (basis × hoogte) ÷ 2. Invullen: (10 × 6) ÷ 2 = 60 ÷ 2 = 30 cm². Een driehoek is altijd de helft van een rechthoek met dezelfde basis en hoogte.",
        "solutionSteps": [
          "Formule: oppervlakte = (basis × hoogte) ÷ 2",
          "Invullen: (10 × 6) ÷ 2",
          "Uitrekenen: 60 ÷ 2 = 30 cm²",
          "Check: rechthoek 10 × 6 = 60 cm², helft = 30 cm² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! (10 × 6) ÷ 2 = 30 cm².",
          "1": "Je bent vergeten te delen door 2. Bij een driehoek deel je altijd door 2: (10 × 6) ÷ 2 = 30 cm².",
          "2": "Je hebt basis + hoogte gedaan (10 + 6 = 16). Voor oppervlakte vermenigvuldig je en deel je door 2.",
          "3": "Je hebt 6 × 6 gedaan. Gebruik de basis (10) én de hoogte (6): (10 × 6) ÷ 2 = 30 cm²."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.area-forgot-halve", "label": "Vergeten te delen door 2", "optionIndex": 1 },
          { "id": "met.area-add-instead-multiply", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 2 },
          { "id": "met.area-wrong-dimension", "label": "Verkeerde afmeting gebruikt", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-002",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "step_solver",
      "question": "Bereken stap voor stap de oppervlakte van een driehoek met basis 14 cm en hoogte 9 cm.",
      "context": "Een tuinontwerper maakt een driehoekig bloembed.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "stepSolver": {
          "context": "Driehoek: basis = 14 cm, hoogte = 9 cm",
          "steps": [
            {
              "prompt": "Wat is basis × hoogte?",
              "correctAnswer": "126",
              "acceptedAnswers": ["126"],
              "hint": "14 × 9 = ?"
            },
            {
              "prompt": "Deel het resultaat door 2. Wat is de oppervlakte?",
              "correctAnswer": "63",
              "acceptedAnswers": ["63", "63 cm²", "63cm²"],
              "hint": "126 ÷ 2 = ?"
            }
          ],
          "showStepsProgressively": true
        }
      },
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 14,
            "height": 9,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte driehoek — stap voor stap",
            "content": "Stap 1: Vermenigvuldig basis × hoogte = 14 × 9 = 126. Stap 2: Deel door 2 = 126 ÷ 2 = 63 cm². De formule is altijd: (b × h) ÷ 2.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_step_by_step",
      "variantIndex": 1,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Oppervlakte driehoek = (basis × hoogte) ÷ 2. Stap 1: 14 × 9 = 126. Stap 2: 126 ÷ 2 = 63 cm². Het bloembed is 63 cm² groot.",
        "solutionSteps": [
          "Formule: (basis × hoogte) ÷ 2",
          "Stap 1: 14 × 9 = 126",
          "Stap 2: 126 ÷ 2 = 63 cm² ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-003",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "fill_in",
      "question": "Een driehoek heeft een basis van 16 cm en een hoogte van 7 cm. Wat is de oppervlakte in cm²?",
      "context": "Een vlaggetje voor een feest heeft deze vorm.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["56", "56 cm²", "56cm²"],
        "caseSensitive": false
      },
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 16,
            "height": 7,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Oppervlakte driehoek berekenen",
            "content": "Formule: (basis × hoogte) ÷ 2. Invullen: (16 × 7) ÷ 2 = 112 ÷ 2 = 56 cm².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_fill_in",
      "variantIndex": 1,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Oppervlakte = (basis × hoogte) ÷ 2 = (16 × 7) ÷ 2 = 112 ÷ 2 = 56 cm². Het vlaggetje is 56 cm² groot.",
        "solutionSteps": [
          "Formule: (basis × hoogte) ÷ 2",
          "Vermenigvuldig: 16 × 7 = 112",
          "Deel door 2: 112 ÷ 2 = 56 cm² ✓"
        ]
      },
      "pedagogy": {
        "dok": 2,
        "hasStructuredData": true
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-004",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "multiple_choice",
      "question": "Een zeilvlak heeft de vorm van een driehoek met een basis van 3,5 m en een hoogte van 4,2 m. Hoeveel vierkante meter stof is er nodig?",
      "context": null,
      "options": ["7,35 m²", "14,70 m²", "7,70 m²", "3,675 m²"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 3.5,
            "height": 4.2,
            "showGrid": false,
            "unit": "m",
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Driehoek met kommagetallen",
            "content": "Dezelfde formule: (b × h) ÷ 2. Met kommagetallen: 3,5 × 4,2 = 14,70. Dan: 14,70 ÷ 2 = 7,35 m².",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_decimal",
      "variantIndex": 1,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Oppervlakte = (basis × hoogte) ÷ 2 = (3,5 × 4,2) ÷ 2 = 14,70 ÷ 2 = 7,35 m². Er is 7,35 m² stof nodig voor het zeil.",
        "solutionSteps": [
          "Formule: (basis × hoogte) ÷ 2",
          "Vermenigvuldig: 3,5 × 4,2 = 14,70",
          "Deel door 2: 14,70 ÷ 2 = 7,35 m² ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! (3,5 × 4,2) ÷ 2 = 7,35 m².",
          "1": "Je bent vergeten te delen door 2. 14,70 is basis × hoogte, maar een driehoek is de helft daarvan.",
          "2": "Je hebt (3,5 + 4,2) × 2 gedaan. Voor oppervlakte vermenigvuldig je basis × hoogte en deel je door 2.",
          "3": "Je hebt 7,35 ÷ 2 gedaan. Je hoeft maar één keer door 2 te delen, niet twee keer."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.area-forgot-halve", "label": "Vergeten te delen door 2", "optionIndex": 1 },
          { "id": "met.area-add-instead-multiply", "label": "Optellen i.p.v. vermenigvuldigen", "optionIndex": 2 },
          { "id": "met.area-double-halve", "label": "Twee keer door 2 gedeeld", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-005",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "fill_in",
      "question": "Een driehoek heeft een oppervlakte van 54 cm² en een basis van 12 cm. Hoe hoog is de driehoek?",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["9", "9 cm", "9cm"],
        "caseSensitive": false
      },
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 12,
            "height": null,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true,
            "unknownDimension": "height",
            "area": 54
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoogte terugrekenen",
            "content": "Formule: opp = (b × h) ÷ 2. Draai om: h = (opp × 2) ÷ b. Invullen: h = (54 × 2) ÷ 12 = 108 ÷ 12 = 9 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_reverse_height",
      "variantIndex": 1,
      "citoDifficulty": 0.60,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "Je weet: oppervlakte = (basis × hoogte) ÷ 2. Draai de formule om: hoogte = (oppervlakte × 2) ÷ basis. Invullen: (54 × 2) ÷ 12 = 108 ÷ 12 = 9 cm.",
        "solutionSteps": [
          "Formule omdraaien: hoogte = (opp × 2) ÷ basis",
          "Invullen: (54 × 2) ÷ 12",
          "Uitrekenen: 108 ÷ 12 = 9 cm ✓"
        ]
      },
      "pedagogy": {
        "dok": 3,
        "hasStructuredData": true
      }
    },
    {
      "id": "MET-OPP-DRIEHOEK-006",
      "familyId": "MET-OPP-DRIEHOEK",
      "module": "Metriek",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "oppervlakte",
      "subSkill": "opp_driehoek",
      "questionType": "multiple_choice",
      "question": "Twee driehoeken hebben allebei een basis van 8 cm. Driehoek A heeft hoogte 5 cm, driehoek B heeft hoogte 10 cm. Hoeveel keer zo groot is driehoek B als driehoek A?",
      "context": null,
      "options": ["2 keer zo groot", "4 keer zo groot", "3 keer zo groot", "1,5 keer zo groot"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 8,
            "height": 5,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true
          }
        },
        {
          "type": "geometricShape",
          "data": {
            "shape": "triangle",
            "base": 8,
            "height": 10,
            "showGrid": false,
            "unit": "cm",
            "showDimensions": true
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Driehoeken vergelijken",
            "content": "Bereken beide oppervlaktes. A: (8 × 5) ÷ 2 = 20 cm². B: (8 × 10) ÷ 2 = 40 cm². Vergelijk: 40 ÷ 20 = 2. Driehoek B is 2× zo groot.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "area_triangle_compare",
      "variantIndex": 1,
      "citoDifficulty": 0.65,
      "citoDiscrimination": 0.81,
      "feedback": {
        "explanationText": "Driehoek A: (8 × 5) ÷ 2 = 20 cm². Driehoek B: (8 × 10) ÷ 2 = 40 cm². 40 ÷ 20 = 2. Driehoek B is precies 2 keer zo groot. Logisch: bij dezelfde basis is de oppervlakte recht evenredig met de hoogte. Dubbele hoogte = dubbele oppervlakte.",
        "solutionSteps": [
          "A: (8 × 5) ÷ 2 = 20 cm²",
          "B: (8 × 10) ÷ 2 = 40 cm²",
          "Vergelijk: 40 ÷ 20 = 2 keer zo groot ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Dubbele hoogte bij dezelfde basis = dubbele oppervlakte.",
          "1": "4 keer zou kloppen als zowel basis als hoogte verdubbelen. Hier verdubbelt alleen de hoogte.",
          "2": "3 keer klopt niet. Reken uit: A = 20 cm², B = 40 cm². 40 ÷ 20 = 2.",
          "3": "1,5 keer klopt niet. De hoogte verdubbelt (5 → 10), dus de oppervlakte verdubbelt ook."
        }
      },
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.area-double-both-dimensions", "label": "Denkt dat beide afmetingen verdubbelen", "optionIndex": 1 },
          { "id": "met.area-wrong-ratio", "label": "Verkeerde verhouding berekend", "optionIndex": 2 },
          { "id": "met.area-wrong-ratio", "label": "Verkeerde verhouding berekend", "optionIndex": 3 }
        ]
      }
    }
  ]
}
